var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKardiachain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 117,
    viewBox: "0 0 128 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 30.7335L22.4623 79.9446L59.071 116.151L22.8096 3.84375L0.460938 30.7335Z",
    fill: "#9C2131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.460938 30.7335L38.833 53.5817L22.8096 3.84375L0.460938 30.7335Z",
    fill: "#576B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3682 0.855957L49.0386 40.2235L56.9602 43.0379L66.291 13.5139L36.3682 0.855957Z",
    fill: "#D71B2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.54 37.936L109.94 62.3648L69.6309 47.7795L81.0723 12.6268L112.224 4.71729L127.54 37.936Z",
    fill: "#C41A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.665 73.9693L72.9775 113.337L54.4961 56.9165L101.665 73.9693Z",
    fill: "#C71C26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5586 17.3754L56.9602 43.0313L66.291 13.5073L52.5586 17.3754Z",
    fill: "#A71927"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.865 40.2235L56.9602 43.0379L52.5586 17.3819L36.3682 0.855957L48.865 40.2235Z",
    fill: "#61395F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8263 53.5817L22.4556 79.9445L0.460938 30.7334L38.8263 53.5817Z",
    fill: "#614268"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0723 12.6338L95.6798 35.1286L69.6309 47.7798L81.0723 12.6338Z",
    fill: "#DA1728"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.231 4.72412L95.6865 35.1285L81.0791 12.6336L112.231 4.72412Z",
    fill: "#E42735"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.94 62.3648L95.6797 35.1216L127.539 37.9359L109.94 62.3648Z",
    fill: "#A61D1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0328 78.711L72.9775 113.33L54.4961 56.9165L74.0328 78.711Z",
    fill: "#D71B2A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9775 113.337L74.0328 78.7176L101.665 73.9692L72.9775 113.337Z",
    fill: "#A51C1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2442 116.144L22.4551 79.938L48.858 84.8598L59.2442 116.144Z",
    fill: "#721919"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKardiachain);
export default __webpack_public_path__ + "static/media/kardiachain.3a9b11c1.svg";
export { ForwardRef as ReactComponent };